import { defHttp } from '/@/utils/http/axios';
import { LoginParams, LoginResultModel, GetUserInfoModel, sendSmsCodeModel } from './model/userModel';

import { ErrorMessageMode } from '/#/axios';

enum Api {
  Login = '/login',
  Logout = '/logout',
  GetUserInfo = '/user',
  GetPermCode = '/getPermCode',
  GetautoLogin = '/autoLogin',
  sendSmsCodeApi = '/sendSmsCode',
  loginPhone = '/loginByPhone',
  GetQyParam = '/qy/weixin/getQyParam',
  GetQyParames ='/qy/weixin/web/getQyParam'
}

/**
 * @description: user login api
 */
export function loginApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
  return defHttp.post<LoginResultModel>(
    {
      url: Api.Login,
      params,
    },
    {
      errorMessageMode: mode,
    },
  );
}

export function loginByPhoneApi(params: LoginParams, mode: ErrorMessageMode = 'modal') {
  return defHttp.post<LoginResultModel>(
    {
      url: Api.loginPhone,
      params,
    },
    {
      errorMessageMode: mode,
    },
  );
}

export function sendSmsCodeApi(params?: Object, mode: ErrorMessageMode = 'modal') {
  return defHttp.get<sendSmsCodeModel[]>(
    { url: Api.sendSmsCodeApi, params },
    {
      errorMessageMode: mode,
    },
  );
}

export function GetQyParam(params?: Object, mode: ErrorMessageMode = 'modal') {
  return defHttp.get<sendSmsCodeModel[]>(
    { url: Api.GetQyParam, params },
    {
      errorMessageMode: mode,
    },
  );
}

export function GetQyParames(params?: Object, mode: ErrorMessageMode = 'modal') {
  return defHttp.get<sendSmsCodeModel[]>(
    { url: Api.GetQyParames, params },
    {
      errorMessageMode: mode,
    },
  );
}

/**
 * @description: getUserInfo
 */
export function getUserInfo() {
  return defHttp.get<GetUserInfoModel>({ url: Api.GetUserInfo }, { errorMessageMode: 'none' });
}

export function getPermCode() {
  return defHttp.get<string[]>({ url: Api.GetPermCode });
}

export function doLogout() {
  return defHttp.post({ url: Api.Logout });
}

export function GetautoLogin(params?: Object, mode: ErrorMessageMode = 'modal') {
  return defHttp.get<string[]>(
    { url: Api.GetautoLogin, params },
    {
      errorMessageMode: mode,
    },
  );
}
